import React from "react";

// Import admin-specific components

import Home from "../jsx/components/Dashboard/Home";

import OrganizationList from "../admin/admincomponent/organization/OrganizationList";
import IndividualList from "../admin/admincomponent/Individual/IndividualList";
import IndividualVerificationForm from "../admin/admincomponent/Individual/IndividualVerificationForm";
import OrganizationVerficationForm from "../admin/admincomponent/organization/OrganizationVerficationForm";
import VerifiedUserList from "../admin/admincomponent/verifiedUser/VerifiedUserList";
import ViewUser from "../admin/admincomponent/verifiedUser/ViewUser";
import InsituteViewUser from "../admin/admincomponent/verifiedUser/InsituteViewUser";
import InsituteVeriedUserList from "../admin/admincomponent/verifiedUser/InsituteVeriedUserList";
import Communication from "../admin/admincomponent/communication/Communication";
import CommunicationList from "../admin/admincomponent/communication/CommunicationList";
import WebsiteNotification from "../admin/admincomponent/communication/WebsiteNotification/WebsiteNotification";
import GovtOrderList from "../admin/admincomponent/govtOrders/GovtOrderList";
import CircularList from "../admin/admincomponent/circulars/CircularList";
import Ticket from "../admin/admincomponent/ticket/Ticket";
import EventCalendar from "../admin/admincomponent/eventCalendar/EventCalendar";
import DSO from "../admin/admincomponent/dso/DSO";
import { DSOProvider } from "../context/DSOContext";
import UserNotification from "../jsx/components/Users/UserNotification";
import EditProfileRequestList from "../admin/admincomponent/editProfile/EditProfileRequestList";
import EditProfileRequestView from "../admin/admincomponent/editProfile/EditProfileRequestView";
import AccountManagement from "../admin/admincomponent/accountManagement/AccountManagement";
import { AccountManagementProvider } from "../context/AccountManagementContext";
import AccountProfileManagement from "../admin/admincomponent/accountManagement/AccountProfileManagement";
import AccountRoleManagement from "../admin/admincomponent/accountManagement/accountRole/AccountRoleManagement";
import AccountAddRoleMangement from "../admin/admincomponent/accountManagement/accountRole/AccountAddRoleMangement";
import AssignUserList from "../admin/admincomponent/accountManagement/accountRole/AssignUserList";
import MenuManagement from "../admin/admincomponent/menuManagement/MenuManagement";
import { MenuManagementProvider } from "../context/MenuManagementContext";
import Error503 from "../jsx/pages/Error503";
import RedireactionComponent from "../admin/admincomponent/redireactionComponent/RedireactionComponent";
import Index from "../admin/admincomponent/BatchManagement/Batches/Index";
import Calendar from "../admin/admincomponent/BatchManagement/Calendar/Index";
import CreateBatch from "../admin/admincomponent/BatchManagement/Batches/CreateBatch";
import ViewBatch from "../admin/admincomponent/BatchManagement/Batches/ViewBatch";
import CreateTraining from "../admin/admincomponent/BatchManagement/Calendar/CreateTraining";
import AcademyDashboard from "../admin/admincomponent/BatchManagement/Dashboard/index";
import AttendanceReport from "../admin/admincomponent/BatchManagement/Attendance/Index";
import { allVenueManagerroutes } from "./VenueManager";
import NewDashboard from "../admin/admincomponent/NewDashboard/newDashboard";
import AllRegistrationList from "../admin/admincomponent/registration/AllRegistrationList";
import SportsList from "../admin/admincomponent/sports/SportsList";
import SportDetail from "../admin/admincomponent/sports/SportDetail";
import CoachesList from "../admin/admincomponent/coaches/CoachesList";
import AthletesList from "../admin/admincomponent/athletes/AthletesList";
import VenuesList from "../admin/admincomponent/venues/VenuesList";
import UddyamaanUnnayan from "../admin/admincomponent/UddyamaanUnnayan/Index";
import UddyamaanUnnayanDashboard from "../admin/admincomponent/UddyamaanUnnayan/Dashboard";
import UddyamaanApplicants from "../admin/admincomponent/UddyamaanUnnayan/Applicants";
import UddyamaanAssessmentList from "../admin/admincomponent/UddyamaanUnnayan/AssessmentList";
import UddyamaanUnnayanAssessment from "../admin/admincomponent/UddyamaanUnnayan/Assessment";
import CmTrophyIndex from "../admin/admincomponent/CmTrophy/Index";
import CmTrophyDashboard from "../admin/admincomponent/CmTrophy/Dashboard";
import CmTrophyApplicants from "../admin/admincomponent/CmTrophy/Applicants";
import CmTrophyApplicationDetail from "../admin/admincomponent/CmTrophy/ApplicationDetail";

export const adminRoutes = [
  { url: "", component: <OrganizationList /> },
  { url: "dashboard", component: <NewDashboard /> },
  { url: "Organization", component: <OrganizationList /> },
  // {url: "newdashboard", component: <NewDashboard /> },
  { url: "Individual", component: <IndividualList /> },
  {
    url: "verification-form/:id",
    component: (
      <OrganizationVerficationForm roleWiseType="insitute" roletype="2" />
    ),
  },
  {
    url: "verification-Individual-form/:id",
    component: (
      <IndividualVerificationForm roleWiseType="individual" roletype="1" />
    ),
  },
  {
    url: "verified-institute-user",
    component: <InsituteVeriedUserList roletype="2" roleCategory="insitute" />,
  },
  {
    url: "verified-individual-user",
    component: <VerifiedUserList roletype="1" roleCategory="individual" />,
  },
  { url: "verification-view-form/:id", component: <ViewUser /> },
  {
    url: "verification-insitute-view-form/:id",
    component: <InsituteViewUser />,
  },
  { url: "communication/communication-list", component: <CommunicationList /> },
  {
    url: "communication/website-notification-list",
    component: <WebsiteNotification />,
  },
  { url: "content/government-orders", component: <GovtOrderList /> },
  { url: "content/circulars", component: <CircularList /> },

  { url: "uddyamaan-unnayan-yojana", component: <UddyamaanUnnayan schemeType="uddyamaan" /> },
  { url: "uddyamaan-unnayan-yojana/dashboard", component: <UddyamaanUnnayanDashboard schemeType="uddyamaan" /> },
  { url: "uddyamaan-unnayan-yojana/applicants", component: <UddyamaanApplicants schemeType="uddyamaan" /> },
  { url: "uddyamaan-unnayan-yojana/assessment", component: <UddyamaanAssessmentList schemeType="uddyamaan" /> },
  { url: "uddyamaan-unnayan-yojana/assessment/:id", component: <UddyamaanUnnayanAssessment schemeType="uddyamaan" /> },
  { url: "protsaahan-yojana", component: <UddyamaanUnnayan schemeType="protsaahan" /> },
  { url: "protsaahan-yojana/dashboard", component: <UddyamaanUnnayanDashboard schemeType="protsaahan" /> },
  { url: "protsaahan-yojana/applicants", component: <UddyamaanApplicants schemeType="protsaahan" /> },
  { url: "protsaahan-yojana/assessment", component: <UddyamaanAssessmentList schemeType="protsaahan" /> },
  { url: "protsaahan-yojana/assessment/:id", component: <UddyamaanUnnayanAssessment schemeType="protsaahan" /> },
  { url: "cm-trophy", component: <CmTrophyIndex /> },
  { url: "cm-trophy/dashboard", component: <CmTrophyDashboard /> },
  { url: "cm-trophy/applicants", component: <CmTrophyApplicants /> },
  { url: "cm-trophy/applications/:id", component: <CmTrophyApplicationDetail /> },
  { url: "all-registrations", component: <AllRegistrationList /> },
  { url: "all-sports", component: <SportsList /> },
  { url: "sport-detail/:sportId", component: <SportDetail /> },
  { url: "all-coaches", component: <CoachesList /> },
  { url: "all-athletes", component: <AthletesList /> },
  { url: "all-venues", component: <VenuesList /> },
  { url: "edit-profile-requests", component: <EditProfileRequestList /> },

  { url: "edit-profile-request-view/:id", component: <EditProfileRequestView /> },



  // {
  //   url: "profile",
  //   component: <ProfileComp />,
  // },
  // { url: "ExcelImport", component: <ImportExcelModal/> },

  // { url: 'user-category', component: <CommonTable fetchData={getAllUserCategory} config={tableConfig['user-category']} /> },
  // { url: 'user-sub-category', component: <SubCategoryList  /> },
  // { url: 'user-category-type', component: <CategoryTypeList /> },
];

export const allAdminroutes = [
  ...adminRoutes,
  {
    url: "manage-dso",
    component: (
      <DSOProvider>
        <DSO />
      </DSOProvider>
    ),
  },

  { url: "communication", component: <Communication /> },
  { url: "redirection_url", component: <RedireactionComponent /> },
  //  { url: "redirection_url", component: <Error503/> },
  // { url: "staging-venue.khelouk.in", component: <Communication /> },
  { url: "communication/communication-list", component: <CommunicationList /> },
  { url: "content/government-orders", component: <GovtOrderList /> },
  { url: "content/circulars", component: <CircularList /> },
  { url: "grievance-management/ticket", component: <Ticket /> },
  { url: "grievance-management/notification", component: <UserNotification /> },
  { url: "grievance-management", component: <Ticket /> },
  {
    url: "communication/website-notification-list",
    component: <WebsiteNotification />,
  },
  {
    url: "event/event-calendar",
    component: <EventCalendar />,
  },
  {

    url: "menu-management/menu",
    component:

      <MenuManagement />
   },
   {
      url: "batch-management/dashboard",
      component: <AcademyDashboard />,
  },
   {
      url: "batch-management/batches",
      component: <Index />,
  },
  {
    url: "batch-management/batches/add",
    component: <CreateBatch />,
  },
  {
    url: "batch-management/batches/viewBatch/:id",
    component: <ViewBatch />
  },
  {
    url: "batch-management/batches/update/:id",
    component: < CreateBatch/>,
  },
  { 
    url: "batch-management/calendar",
    component: <Calendar />,
  },
  {
    url: "batch-management/calendar/create-training",
    component: <CreateTraining />,
  },
  {
    url: "batch-management/calendar/update/:id",
    component: <CreateTraining />,

  },
  {
    url: "batch-management/attendance-report",
    component: <AttendanceReport />,
  },
  {
    url: "account/accountmanagement",
    component: (
      <AccountManagement/>
    ),
  },
  {
    url: "account/account-profile/:id",
    component: (
      <AccountProfileManagement />
    ),

  },

  {
    url: "account/role",
    component: (
      <AccountRoleManagement />
    ),
  },
  {
    url: "account/role/add",
    component: (
      <AccountAddRoleMangement />
    ),
  },
  {
    url: "account/role/update/:id",
    component: (
      <AccountAddRoleMangement />
    ),
  },
  {
    url: "account/role-assign/:id",
    component: (
      <AssignUserList />
    ),
  },
  ...allVenueManagerroutes
];
